import { DataBean } from "../DataBean";


export class CreateSupplier extends DataBean {


    public async createSupplier(nit: number | null, idemployee: number | null, supplier: any | null): Promise<any> {
        return this.getCustomService("SupplierERP", "com.orange.finance.supplier.bean.Supplier_createSupplier_Number_Number_com.orange.finance.supplier.bean.Supplier", [nit, idemployee, supplier]);
    }
    
    public async getSupplierCatalogPorPropiedad(property:any,value:any): Promise<any> {
        return this.getCustomService("SupplierERP", 
            "java.util.List_getSupplierCatalogPorPropiedad_String_Object_Number", 
            [property, value,null]);
    }




}